import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=23f4be2a&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=23f4be2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f4be2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23f4be2a')) {
      api.createRecord('23f4be2a', component.options)
    } else {
      api.reload('23f4be2a', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=23f4be2a&scoped=true&", function () {
      api.rerender('23f4be2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Common/Header.vue"
export default component.exports